import { lerp } from './assets/_utils'

const elmStalker = document.querySelector('.stalker:not(.is-static)')
if (elmStalker) {
  const elmText = elmStalker.querySelector('.stalker__text')

  const state = {
    multiplier: 0.3,
    currentX: 0,
    currentY: 0,
    targetX: 0,
    targetY: 0,
  }

  const targetElms = document.querySelectorAll('.js-stalker-target')

  /**
   * マウスが移動した時の処理
   */
  document.addEventListener('mousemove', (e) => {
    state.targetX = e.clientX
    state.targetY = e.clientY
  })

  /**
   * マウスが画面から外れた時の処理
   */
  document.addEventListener('mouseleave', (e) => {
    elmStalker.classList.remove('is-show')
  })

  /**
   * スクロールした時の処理
   */
  document.addEventListener('scroll', (e) => {
    let result = null
    targetElms.forEach((target) => {
      // カーソルの現在位置 (X, Y)
      const mouseX = state.targetX
      const mouseY = state.targetY

      // 対象要素の領域情報を取得
      const rect = target.getBoundingClientRect()

      // カーソルが領域内にあるかチェック
      if (mouseX >= rect.left && mouseX <= rect.right && mouseY >= rect.top && mouseY <= rect.bottom) {
        result = target
      }
    })

    if (result) {
      showStalker(result)
    } else {
      hideStalker()
    }
  })

  /**
   * 対象に対する処理
   */
  targetElms.forEach((target) => {
    /**
     * 対象にマウスが乗った時の処理
     */
    target.addEventListener('mouseover', (e) => {
      showStalker(target)
    })

    /**
     * 対象からマウスが離れた時の処理
     */
    target.addEventListener('mouseout', (e) => {
      elmStalker.classList.remove('is-show')
    })
  })

  /**
   * ストーカーを表示
   */
  const showStalker = (target) => {
    const text = target.dataset.stalkerText
    if (elmText) {
      if (text !== undefined) {
        elmText.innerHTML = text
      } else {
        elmText.innerHTML = 'VIEW MORE'
      }
    }

    elmStalker.classList.add('is-show')
  }

  /**
   * ストーカーを非表示
   */
  const hideStalker = () => {
    elmStalker.classList.remove('is-show')
  }

  /**
   * 更新処理
   */
  const update = () => {
    state.currentX = lerp(state.currentX, state.targetX, state.multiplier)
    state.currentY = lerp(state.currentY, state.targetY, state.multiplier)

    elmStalker.style.top = state.currentY + 'px'
    elmStalker.style.left = state.currentX + 'px'

    requestAnimationFrame(update)
  }
  update()
}
